import React from 'react';
import {
  compose,
  setDisplayName,
} from 'recompose';
import ReactAnimateHeight from 'react-animate-height';
import { Display } from '@ux/typeface';
import { FormattedMessage } from 'react-intl';
import { withStyles } from '@ux/style-utils';
import stylesheet from './Steps.stylesheet';

export const PureSteps = ({
  theme,
  height,
  styles,
}) => (
  <ReactAnimateHeight
    height={height}
    duration={300}
    animateOpacity={true}
  >
    <ol style={styles.info}>
      <For
        each="step"
        of={[ 1, 2, 3 ]}
      >
        <li
          key="step"
          style={styles.step}
        >
          <Display
            theme={theme}
            component="span"
            style={styles.number}
          >
            {step}
          </Display>
          <span style={styles.text}>
            <FormattedMessage id={`dst.negotiate.v2.step${step}`}/>
          </span>
        </li>
      </For>
    </ol>
  </ReactAnimateHeight>
);

export const enhance = compose(
  setDisplayName('NegotiateSteps'),
  withStyles(stylesheet),
);

export default enhance(PureSteps);
